import "./MarketingCarousel.css";
import React from "react";
import Carousel from "gradifui/components/carousel/Carousel";
import map from "lodash/map";
import { URLS } from "util/constants";

export const MARKETING_CARDS = {
    FINCORE: 0,
    SLP: 1,
    CSU: 2
};

const MARKETING_CAROUSEL_SUPERSCRPTS = {
    FinancialCore: (i) => i,
    PayDown: (i) => i + 1,
    SaveUp: (i) => i + 2
};

const marketingData = [
    {
        imagePath: require("../assets/redesign2020/marketing-carousel/fincore.png"),
        logoPath: require("../assets/redesign2020/fincore-logo.svg"),
        logoText: "FinancialCore",
        imageAlt: "Financial Core",
        text: <React.Fragment><span className="header-line-1">You can help Rebecca save up to</span><span className="marketing-carousel-highlight"><span className="dollar-sign">$</span>9,576</span> in interest off her student loan debt.</React.Fragment>,
        link: URLS.MARKETING.REFI
    },
    {
        imagePath: require("../assets/redesign2020/marketing-carousel/slp.png"),
        logoPath: require("../assets/redesign2020/slp-logo.svg"),
        logoText: "PayDown",
        imageAlt: "Student Loan Paydown",
        text: <React.Fragment><span className="header-line-1">You can help Alex save up to 2 &frac12; years or </span><span className="marketing-carousel-highlight"><span className="dollar-sign">$</span>17,900</span> off her student loan debt.</React.Fragment>,
        link: URLS.MARKETING.PAYDOWN
    },
    {
        imagePath: require("../assets/redesign2020/marketing-carousel/csu.png"),
        logoPath: require("../assets/redesign2020/csu-logo.svg"),
        logoText: "SaveUp",
        imageAlt: "College SaveUp",
        text: <React.Fragment><span className="header-line-1">You can help Ethan save up to</span><span className="marketing-carousel-highlight"><span className="dollar-sign">$</span>15,293</span> in a 529 plan for his daughter's education.</React.Fragment>,
        link: URLS.MARKETING.SAVEUP
    }
];

export default ({ defaultProduct, carouselLegalSuperScript }) => {
    return (
        <div className="marketing-carousel">
            <h3 className="marketing-carousel-header">EXPLORE THE GRADIFI SUITE OF SOLUTIONS</h3>
            <Carousel default={defaultProduct}>
                {map(marketingData, ({
                    imagePath,
                    logoPath,
                    imageAlt,
                    logoText,
                    text,
                    link
                }, i) => (
                    <div key={i} className="marketing-carousel-child">
                        <div className="marketing-carousel-image-wrapper">
                            <div className="marketing-carousel-logo-button animate">
                                <img className="marketing-carousel-logo" alt={imageAlt} src={logoPath} />
                                {logoText}
                            </div>
                            <div className="marketing-carousel-overlay" />
                            <img className="marketing-carousel-image animate" src={imagePath} alt={imageAlt} />
                        </div>
                        <div className="marketing-carousel-body-wrapper">
                            <div className="marketing-carousel-body animate">
                                <h3 className="marketing-carousel-bodytext">
                                    {text}
                                    <sup>{MARKETING_CAROUSEL_SUPERSCRPTS[logoText](carouselLegalSuperScript)}</sup>
                                </h3>
                                <a className="button" tabIndex="0" href={link}>LEARN MORE</a>
                            </div>
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};